import type { ReactNode } from "react"
import { usePermission } from "@/hooks/usePermission"
import type { PermissionKey } from "@/lib/permissions"

interface PermissionGateProps {
  permission: PermissionKey
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Renders children only when the current user has the given permission.
 * Use for hiding financial data, team management, etc.
 */
export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  const { hasPermission, loading } = usePermission(permission)
  if (loading) return null
  return hasPermission ? <>{children}</> : <>{fallback}</>
}
